import React, { useEffect, useState } from 'react';
import { ExclamationIcon } from '@heroicons/react/solid';
import { FeatureCard } from './FeatureCard';
import { Tab } from '@headlessui/react';
import clsx from 'clsx';
import InstallBanner from './InstallBanner';
import WelcomeBanner from './WelcomeBanner';

const FeatureTabGroup = ({ selectedTab }) => {
	const features = [
		{
			name: 'App Install Banner',
			component: <InstallBanner />,
		},
		{
			name: 'App Welcome Banner',
			component: <WelcomeBanner />,
		},
	];
	return (
		<Tab.Group defaultIndex={selectedTab === 'install-banner' ? 0 : 1}>
			<Tab.List
				as="div"
				className="flex flex-row rounded-md overflow-hidden justify-self-start"
			>
				{features.map((feature) => (
					<Tab key={feature.name}>
						{({ selected }) => (
							<button
								className={clsx(
									selected
										? 'bg-blue-500 text-white font-medium'
										: 'text-black bg-gray-100',
									'px-12 py-3'
								)}
							>
								{feature.name}
							</button>
						)}
					</Tab>
				))}
			</Tab.List>
			<Tab.Panels>
				{features.map((feature) => (
					<Tab.Panel key={feature.name}>{feature.component}</Tab.Panel>
				))}
			</Tab.Panels>
		</Tab.Group>
	);
};

const AppInstallCampaign = () => {
	const [selectedFeature, setSelectedFeature] = useState(null);

	// TODO: Check if the app is configured
	const isConfigured = false;
	
	return (
		<div className="p-6">
			{/* {!isConfigured && (
				<div className="mb-2 text-sm text-gray-800 bg-red-100 p-2 rounded-md border border-red-300 border-dashed flex flex-row items-center justify-center gap-2">
					<ExclamationIcon className="w-6 h-6 text-red-700" />
					<p>
						Push Notifications can only be sent once your app is live. For more
						information on launching your app, please{' '}
						<a
							href="#" //TODO: Add link
							className="text-indigo-600 underline"
						>
							click here
						</a>
						.
					</p>
				</div>
			)} */}
			{selectedFeature ? (
				<FeatureTabGroup selectedTab={selectedFeature} />
			) : (
				<div className="mb-6 flex flex-row gap-4">
					<FeatureCard
						title="App Install Banner"
						description="An app-install banner will prompt website visitors to download the app and take them to the app store once they click on it. Offer a discount on the first in-app purchase and display the code on the banner to encourage more downloads."
						featureImage="https://d3myyafggcycom.cloudfront.net/assets/install-banner.png"
						onClick={() => {
							setSelectedFeature('install-banner')
						}}
					/>
					<FeatureCard
						title="App Welcome Banner"
						description="A welcome screen will greet your customers when they launch your app, before the homepage of your app loads. This is the first interaction that your customers will have with your brand's app, make it count!"
						featureImage="https://d3myyafggcycom.cloudfront.net/assets/web-banner.png"
						onClick={() => {
							setSelectedFeature('welcome-banner')
						}}
					/>
				</div>
			)}
		</div>
	);
};

export default AppInstallCampaign;
